// Leaf helpers for reading/writing a dotted-path value in a section state object.
// Kept in their own module so QuestionField and sectionValidation can both use
// them without importing each other (avoids a circular import).

export const getValueAt = (section, key) => {
  if (!key) return undefined
  return key.split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), section)
}

export const setValueAt = (sectionState, key, value) => {
  const parts = key.split(".")
  if (parts.length === 1) return { [key]: value }
  const [head, ...rest] = parts
  const prevHead = sectionState?.[head] ?? {}
  const tailPatch = rest.reduceRight((acc, k) => ({ [k]: acc }), value)
  return { [head]: { ...prevHead, ...tailPatch } }
}
